<!--
 Copyright (C) 2021 Fair Supply Analytics Pty Ltd - All Rights Reserved
 Unauthorized copying of this file, via any medium is strictly prohibited.
 Proprietary and confidential.
-->

<div *ngIf="visible" class="alert alert-{{ type }}" role="alert">
  {{ message }}
</div>
